module.exports = __webpack_public_path__ + "assets/img/luxury.897e7ae6.jpg";